import React, { useEffect } from 'react'
import { useOption } from 'react-aria'
import { SelectState } from 'react-stately'
import styled from 'styled-components'
import { Flex, Text } from '../../../../core-components'

type Props = {
  INTERNAL_isFocused?: boolean
  item: NonNullable<ReturnType<SelectState<object>['collection']['getItem']>>
  state: SelectState<object>
}

export const YearMonthItem = ({ item, state, INTERNAL_isFocused }: Props) => {
  const ref = React.useRef<HTMLLIElement>(null)
  const { optionProps, isSelected, isFocused } = useOption({ key: item.key }, state, ref)
  useEffect(() => {
    if (isSelected) {
      ref.current?.scrollIntoView({ block: 'nearest' })
    }
  }, [isSelected])
  return (
    <StyledFlex
      as='li'
      h={8}
      borderRadius={10}
      bg={getBg(isSelected, INTERNAL_isFocused || isFocused)}
      alignItems='center'
      justifyContent='center'
      ref={ref}
      {...optionProps}
    >
      <Text
        textStyle={isSelected ? 'item-selected' : 'item-unselected'}
        color={isSelected ? 'fg/major' : 'fg/moderate'}
      >
        {item.rendered}
      </Text>
    </StyledFlex>
  )
}

const StyledFlex = styled(Flex)`
  cursor: pointer;
  :focus {
    outline: none;
  }
`

const getBg = (isSelected: boolean, isFocused: boolean) => {
  if (isSelected) {
    return 'bg/major'
  }
  if (isFocused) {
    return 'bg/list-item-hovered'
  }
}
